import { useQuery } from "react-query";
import qs from "qs-lite";
import api from "../../utils/api";
import { getQueryParams } from "../../helpers";

const LINES = "/lineitems";

const getAllLineItems = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${LINES}?${queryString}`);
};
export const useGetAllLineItems = ({ locationId = 1, startDate, endDate }) => {
  const queryProps = getQueryParams({
    prefix: "lineItem",
    defaultOrderBy: "dueDate",
    defaultSortOrder: "desc",
    include: [
      ["location", locationId],
      ["startDate", startDate],
      ["endDate", endDate],
      ["status", null],
      ["lineItemIds", false],
    ],
  });

  return useQuery([LINES, { ...queryProps }], getAllLineItems);
};

const getBoxingData = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${LINES}/boxing?${queryString}`);
};
export const useGetBoxingData = ({ ids = [], open = false }) => {
  const lineItemIds = ids?.join("-");
  return useQuery([LINES, { lineItemIds }], getBoxingData, {
    enabled: !!(ids?.length && open),
  });
};
